import * as Actions from './studio.actions';
import {AusmitError} from "../../shared/interfaces";
import {EmptyPaginator, PaginatorModel} from "../../shared/interfaces/PaginatorModel";
import {CriteriaModel, EmptyCriteria} from "../../shared/interfaces/CriteriaModel";

/*Defining the state shape*/
export interface State {
	error: AusmitError | null;
	hasError: boolean;
	requestProcessing: boolean;
	GetStudios: {
		criteria: CriteriaModel;
		response: PaginatorModel;
	};
	LikeStudio: {
		success: boolean;
		response: any;
	};
	PostComment: {
		success: boolean;
		response: any;
	};
}

/*Setting the initial state*/
export const initialState: State = {
	error: null,
	hasError: false,
	requestProcessing: false,
	GetStudios: {
		criteria: EmptyCriteria,
		response: EmptyPaginator,
	},
	LikeStudio: {
		success: false,
		response: null,
	},
	PostComment: {
		success: false,
		response: null,
	},
};

/*Creating the reducer function*/
export function StudioReducer(
	state = initialState,
	action: Actions.Actions
): State {
	switch (action.type) {
		case Actions.ActionTypes.GetStudiosSilently: {
			return {
				...state,
				GetStudios: {
					...state.GetStudios,
					criteria: action.payload
				}
			};
		}

		case Actions.ActionTypes.GetStudios: {
			return {
				...state,
				requestProcessing: true,
				GetStudios: {
					...state.GetStudios,
					criteria: action.payload
				}
			};
		}
		case Actions.ActionTypes.GetStudiosSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				requestProcessing: false,
				GetStudios: {
					...state.GetStudios,
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.GetStudiosError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				GetStudios: {
					...state.GetStudios,
				}
			};
		}

		case Actions.ActionTypes.DisLikeStudio: {
			return {
				...state,
				requestProcessing: true,
				LikeStudio: {
					success: false,
					response: null,
				}
			};
		}
		case Actions.ActionTypes.LikeStudio: {
			return {
				...state,
				requestProcessing: true,
				LikeStudio: {
					success: false,
					response: null,
				}
			};
		}
		case Actions.ActionTypes.LikeStudioSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				requestProcessing: false,
				LikeStudio: {
					success: true,
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.LikeStudioError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				LikeStudio: {
					success: false,
					response: null,
				}
			};
		}

		case Actions.ActionTypes.PostComment: {
			return {
				...state,
				requestProcessing: true,
				PostComment: {
					success: false,
					response: null,
				}
			};
		}
		case Actions.ActionTypes.PostCommentSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				requestProcessing: false,
				PostComment: {
					success: true,
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.PostCommentError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
				PostComment: {
					success: false,
					response: null,
				}
			};
		}

		default:
			return state;
	}
}
